import React from 'react';
import {
  CandidatePsleResultReleaseSchema,
  CandidateResultReleaseSchema
} from '../../models/@candidate/CandidateResultReleaseSchema';
import PsleResults from './PsleResults';
import GeneralResults from './GeneralResults';

export interface IndividualResultReleaseProps {
  candidateResultData: CandidateResultReleaseSchema | CandidatePsleResultReleaseSchema;
  eligibleForResit?: boolean;
  eligibleForAppeal?: boolean;
  listingCode?: any;
}

const IndividualResultRelease = ({
  candidateResultData,
  eligibleForResit = false,
  eligibleForAppeal = false,
  listingCode
}: IndividualResultReleaseProps) => {
  const instanceOfPsleResults = (
    results: CandidateResultReleaseSchema | CandidatePsleResultReleaseSchema
  ): results is CandidatePsleResultReleaseSchema => 'psleScore' in results;

  return instanceOfPsleResults(candidateResultData) ? (
    <PsleResults
      candidateResultData={candidateResultData}
      eligibleForResit={false}
      eligibleForAppeal={eligibleForAppeal}
      listingCode={listingCode}
      examLevel={candidateResultData.examLevel}
    />
  ) : (
    <GeneralResults
      candidateResultData={candidateResultData}
      eligibleForResit={eligibleForResit}
      eligibleForAppeal={eligibleForAppeal}
      listingCode={listingCode}
      examLevel={candidateResultData.examLevel}
    />
  );
};

export default IndividualResultRelease;
